/* tslint:disable */

declare var Object: any;
export interface PatientPukInterface {
  "patientId": string;
  "puk": string;
  "created": Date;
  "used"?: boolean;
  "ttl"?: number;
  "id"?: any;
}

export class PatientPuk implements PatientPukInterface {
  "patientId": string;
  "puk": string;
  "created": Date;
  "used": boolean;
  "ttl": number;
  "id": any;
  constructor(data?: PatientPukInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PatientPuk`.
   */
  public static getModelName() {
    return "PatientPuk";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PatientPuk for dynamic purposes.
  **/
  public static factory(data: PatientPukInterface): PatientPuk{
    return new PatientPuk(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PatientPuk',
      plural: 'PatientPuks',
      path: 'PatientPuks',
      idName: 'id',
      properties: {
        "patientId": {
          name: 'patientId',
          type: 'string'
        },
        "puk": {
          name: 'puk',
          type: 'string'
        },
        "created": {
          name: 'created',
          type: 'Date'
        },
        "used": {
          name: 'used',
          type: 'boolean',
          default: false
        },
        "ttl": {
          name: 'ttl',
          type: 'number',
          default: 43200
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
